// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    header: {
        size: {
            sticky: 56,
            height: 138,
        },
        mobile: {
            size: {
                authenticated: 100,
                unAuthenticated: 54,
            },
        },
        tablet: {
            size: {
                authenticated: 58,
                unAuthenticated: 54,
            },
        },
    },
    footer: {
        offsetTop: 44,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 230,
            height: 230,
        },
        mobile: {
            width: 280,
            height: 280,
        },
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage" as any;
export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
}

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};

export const TESTIMONIALS_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1,
    tablet: 1,
    desktop: 2,
};

export const FEATURED_CATEGORIES_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1.5,
    tablet: 3.3,
    desktop: 6,
};

export const PRODUCT_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 1,
    tablet: 2,
    desktop: 3.7,
    wideScreen: 4.5,
};

export const checkoutPages = ["CheckoutShippingPage", "CheckoutReviewAndSubmitPage", "OnePageCheckoutPage"];

export const interactionPages = [
    "CheckoutShippingPage",
    "CheckoutReviewAndSubmitPage",
    "OnePageCheckoutPage",
    "CartPage",
    "ProductDetailsPage",
    "ProductListPage",
    "OrderConfirmationPage",
];

export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";

export const SHOW_ALL_BRANDS_KEY = "all";

export const TRANSLATE_OBJECT = { translate: "no" };
export const SHIPPING_FORM = "ShippingForm";

export const GOOGLE_EVENTS = {
    VIEW_ITEM_LIST: "view_item_list",
    SELECT_ITEM: "select_item",
    VIEW_CART: "view_cart",
    ADD_TO_WISHLIST: "add_to_wishlist",
    REMOVE_FROM_CART: "remove_from_cart",
    ADD_TO_CART: "add_to_cart",
    BEGIN_CHECKOUT: "begin_checkout",
    ADD_SHIPPING_INFO: "add_shipping_info",
    ADD_PAYMENT_INFO: "add_payment_info",
    PURCHASE: "purchase",
    VIEW_ITEM: "view_item",
    LOGIN: "login",
    SEARCH: "search",
    CONTACT_US: "contact_us",
    PLP_FILTER: "plp_filter",
    PLP_SEARCH: "plp_search",
    PDP_SHARE: "pdp_share",
    REQUEST_A_QUOTE: "request_a_quote",
    MY_ACCT_QUICKLINKS: "my_acct_quicklinks",
    MY_ACCT_FLYOUT: "my_acct_flyout",
    NAV_BAR_CLICK: "nav_bar",
    TOOL_BAR_NAV: "tool_bar_nav",
    REQUEST_ACCOUNT: "request_account",
    LOCATIONS: "locations",
    MYACCT_MYLISTS: "myacct_mylists",
    MYACCT_QUOTES: "myacct_quotes",
    ADD_LIST_TO_CART: "add_list_to_cart",
    MYACCT_LISTS_MOREACTIONS: "myacct_lists_moreactions",
    QUICK_ORDER_SEARCH: "quickorder_search",
    QUICK_ORDER_UPLOAD: "quick_order_upload",
    REQUEST_PRODUCT: "request_product",
    EDIT_CART: "edit_cart",
    REORDER: "reorder",
    MYACCT_ORDERHISTORY_DATERANGE: "myacct_orderhistory_daterange",
    MYACCT_ORDERHISTORY_SHIPTO: "myacct_orderhistory_shipto",
    MYACCT_ORDER: "myacct_order",
    QUOTE_ACCEPTED: "myacct_quote_accept",
    QUOTE_DECLINED: "myacct_quote_decline",
    QUOTE_PROPOSED: "myacct_quote_prop",
    CONTACT_SALES: "contact_sales",
    PDP_IMAGE_CLICK: "pdp_image_click",
    MYACCT_ADD_USER: "myacct_add_user",
    MYACCT_EDIT_USER: "myacct_edit_user",
    MYACCT_VIEW_USER: "myacct_view_user",
    FOOTER_CLICKS: "footer_clicks",
    FILE_DOWNLOAD: "file_download",
    PDP_WAREHOUSE_INVENTORY: "pdp_warehouse_inventory",
    LOGIN_ISSUE: "login_issue",
    INDUSTRIES_SERVED: "industries_served",
    MYACCT_RECENT_ORDERS: "myacct_recent_orders",
    HOMEPAGE_RIBBON: "homepage_ribbon",
};

export const CHECKOUT_STEPS = {
    CART: 0,
    ADDRESS: 1,
    SHIPPING: 2,
    PAYMENT: 3,
    REVIEW: 4,
};
